module.exports = __webpack_public_path__ + "img/4-1.f3994fa.png";